import { useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Menu } from 'shared/ui'
import { TrialProgress } from 'entities/Subscription/ui/TrialProgress'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { AnalyticsKey } from 'widgets/Menu/ui/MenuAnalytics/constants/menuItems'
import { MenuAnalyticsStore } from 'widgets/Menu/ui/MenuAnalytics/store/menuAnalyticsStore'

export const MenuAnalytics = observer(() => {
  const key = AnalyticsKey
  const entities = useEntitiesContext()
  const [store] = useState(() => new MenuAnalyticsStore(key, entities))

  useEffect(() => {
    store.menuStore.init()
  }, [])

  if (store.menuStore.loading) return null

  return <Menu title={'Analytics'} menuItems={store.menuItems} bottomNode={<TrialProgress />} />
})
